import React, { useState, useEffect } from 'react'
import { EntryCollection } from 'contentful'
import {
    Card,
    CardContentInformation,
    CardTypographyDate,
    CardTypographyTitle,
    ContentInformation,
    ContentSearch,
    ContentSearchIcon,
    ImageCard,
    Information,
    OverSection,
    Search,
    TypographyTitle,
} from './styles'
import { client } from 'src/api/contenfull'
import { EntryFields } from 'types/contenfull'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { FaSearch } from 'react-icons/fa'
import { useTranslations,useI18nInstance } from "src/provider/LocaleProvider";

export const SearchSection = () => {
    const t = useTranslations()
    const i18n = useI18nInstance()
    const [searchTermEs, setSearchTermEs] = useState('')
    const [searchResultsEs, setSearchResultsEs] =
        useState<EntryCollection<EntryFields> | null>(null)
    const [searchTerm, setSearchTerm] = useState('')
    const [searchResults, setSearchResults] =
        useState<EntryCollection<EntryFields> | null>(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const handleSearch = async () => {
            setLoading(true)

            try {
                const response = await client.getEntries<EntryFields>({
                    content_type: 'blogs',
                    'fields.tittleContent[match]': searchTerm,
                })

                setSearchResults(response)
            } catch (error) {
                console.error('Error fetching search results:', error)
            }

            setLoading(false)
        }

        handleSearch().then()
    }, [searchTerm])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value)
    }

    useEffect(() => {
        const handleSearchEs = async () => {
            setLoading(true)

            try {
                const response = await client.getEntries<EntryFields>({
                    content_type: 'blogs',
                    'fields.tittleContentEs[match]': searchTermEs,
                })

                setSearchResultsEs(response)
            } catch (error) {
                console.error('Error fetching search results:', error)
            }

            setLoading(false)
        }

        handleSearchEs().then()
    }, [searchTermEs])

    const handleChangeEs = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTermEs(event.target.value)
    }

    return (
        <OverSection>
            <ContentSearch>
                {i18n.language === 'es' ? (
                    <Search
                        type="text"
                        value={searchTermEs}
                        onChange={handleChangeEs}
                    />
                ) : (
                    <Search
                        type="text"
                        value={searchTerm}
                        onChange={handleChange}
                    />
                )}
                <ContentSearchIcon>
                    <FaSearch color={'black'} />
                </ContentSearchIcon>
            </ContentSearch>
            <ContentInformation marginTop={'xxmedium'}>
                {searchResults && (
                    <Information padding={'xmedium'}>
                        <TypographyTitle
                            variant={'h2'}
                            fontSize={'xxlarge'}
                            fontWeight={400}
                        >
                            {t('blog.recentBlog.search')}
                        </TypographyTitle>
                        {loading && <p>Loading...</p>}
                        {i18n.language === 'es' ? (
                            <>
                                {searchResultsEs &&
                                    searchResultsEs.items.length === 0 && (
                                        <p>Sin Datos</p>
                                    )}
                            </>
                        ) : (
                            <>
                                {searchResults &&
                                    searchResults.items.length === 0 && (
                                        <p>No data</p>
                                    )}
                            </>
                        )}
                        {i18n.language === 'es' ? (
                            <>
                                {searchResultsEs?.items.map((entry) => (
                                    <Card
                                        key={entry.sys.id}
                                        to={`/blog/${entry.sys?.id}`}
                                    >
                                        <ImageCard
                                            src={
                                                entry.fields.imageOne.fields
                                                    .file.url
                                            }
                                            alt={entry.fields.tittleContent}
                                        />
                                        <CardContentInformation>
                                            <CardTypographyDate
                                                variant={'h3'}
                                                fontSize={'xsmall'}
                                                fontWeight={400}
                                            >
                                                {format(
                                                    new Date(entry.fields.date),
                                                    'eeee dd, MMMM yyyy',
                                                    { locale: es }
                                                )}
                                            </CardTypographyDate>
                                            <CardTypographyTitle
                                                variant={'h3'}
                                                fontSize={'xxsmall'}
                                                fontWeight={500}
                                            >
                                                {entry.fields.tittleContentEs}
                                            </CardTypographyTitle>
                                        </CardContentInformation>
                                    </Card>
                                ))}
                            </>
                        ) : (
                            <>
                                {searchResults?.items.map((entry) => (
                                    <Card
                                        key={entry.sys.id}
                                        to={`/blog/${entry.sys?.id}`}
                                    >
                                        <ImageCard
                                            src={
                                                entry.fields.imageOne.fields
                                                    .file.url
                                            }
                                            alt={entry.fields.tittleContent}
                                        />
                                        <CardContentInformation>
                                            <CardTypographyDate
                                                variant={'h3'}
                                                fontSize={'xsmall'}
                                                fontWeight={400}
                                            >
                                                {format(
                                                    new Date(entry.fields.date),
                                                    'eeee dd, MMMM yyyy'
                                                )}
                                            </CardTypographyDate>
                                            <CardTypographyTitle
                                                variant={'h3'}
                                                fontSize={'xxsmall'}
                                                fontWeight={500}
                                            >
                                                {entry.fields.tittleContent}
                                            </CardTypographyTitle>
                                        </CardContentInformation>
                                    </Card>
                                ))}
                            </>
                        )}
                    </Information>
                )}
            </ContentInformation>
        </OverSection>
    )
}
